import React, { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  postConfiguration,
  getConfiguration,
} from "../../../../services/Handlers/ConfigurationService";
import { useAuth } from "../../../../context/AuthProvider";
import ConfigurationComponents from "../components";
import { useNotification } from "../../../../context/NotificationProvider";

export default function Configuration() {
  const { userDetail } = useAuth();
  const { error, success } = useNotification();
  const [configData, setConfigData] = useState({
    restrict_to_owner_data: false,
  });

  const { isLoading, refetch } = useQuery(
    ["BusinessConfiguration", userDetail?.businessId],
    () => getConfiguration(userDetail?.businessId),
    {
      enabled: !!userDetail?.businessId,
      onSuccess: (res) => {
        if (res.status === 200) {
          if (res?.data?.data) {
            setConfigData({
              restrict_to_owner_data:
                res.data.data.restrict_to_owner_data || false,
            });
          }
        }
      },
      onError: (error) => {
        console.error("Failed to fetch configuration:", error);

        if (error?.response?.status !== 404) {
          error("Gagal memuat konfigurasi");
        }
      },
    }
  );

  const { mutate: saveConfiguration, isLoading: isSaving } = useMutation(
    (data) => postConfiguration(data),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          success("Konfigurasi berhasil disimpan");
          refetch();
        }
      },
      onError: (error) => {
        console.error("Failed to save configuration:", error);
        error("Gagal menyimpan konfigurasi");
      },
    }
  );

  const handleConfigChange = (field, value) => {
    setConfigData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    if (!userDetail?.businessId) {
      error("Business ID tidak ditemukan");
      return;
    }

    const payload = {
      busines_id: parseInt(userDetail.businessId),
      restrict_to_owner_data: configData.restrict_to_owner_data,
    };

    saveConfiguration(payload);
  };

  const handleReset = () => {
    setConfigData({
      restrict_to_owner_data: false,
    });
  };

  return (
    <ConfigurationComponents
      configData={configData}
      onConfigChange={handleConfigChange}
      onSave={handleSave}
      onReset={handleReset}
      isLoading={isLoading}
      isSaving={isSaving}
      businessName={userDetail?.businessName || ""}
    />
  );
}
